import type { WidgetMapperProps } from "../WidgetsMapper";

/** Human-readable labels for each widget, used in the ordering side panel. */
export const widgetLabels: Record<WidgetMapperProps["widgetName"], string> = {
	PortfolioPerformance: "Portfolio Performance",
	PortfolioMonitoringBlock: "Portfolio Monitoring",
	PerformanceMetricsBlock: "Performance Metrics",
	ExanteMetricsBlock: "Ex-Ante Metrics",
	PortfolioCommentaryMDBlock: "Portfolio Commentary",
	ExposureEvolve: "Exposure Evolution",
	PortfolioHistoryBlock: "Portfolio History",
	Attribution: "Attribution",
	ContributionVolatility: "Contribution & Volatility",
	ExanteContributionVolatility: "Ex-Ante Contribution & Volatility",
	PortfolioFactorsExposure: "Factors Exposure",
	ExposureCompare: "Exposure Compare",
	MaturityCouponTracker: "Maturity & Coupon Tracker",
	BondsDividendsTracker: "Income tracker",
	Composition: "Composition",
	ACROutlookExpected: "ACR Outlook Expected",
	ReturnAnalysis: "Return Analysis",
	FactorsExposure: "Factors Exposure",
	AssetClassOverviewBlock: "Asset Class Overview",
	OutlookBlock: "Outlook",
	CommentaryMDBlock: "Commentary",
	Positioning: "Positioning",
	Forecast: "Forecast",
	MarketRegimeAnalysisBlock: "Market Regime Analysis",
	ScenarioDescriptionBlock: "Scenario Description",
	PastMarketRegimesBlock: "Past Market Regimes",
	EvolutionOfRegimeProbabilitiesBlock: "Evolution of Regime Probabilities",
	RegimeTransitionMatrix2WBlock: "Regime Transition Matrix (2W)",
	RegimeTransitionMatrix1MBlock: "Regime Transition Matrix (1M)",
	RegimeTransitionMatrix3MBlock: "Regime Transition Matrix (3M)",
	RegimeBreakdownBySectorBlock: "Regime Breakdown by Sector",
	CurrentRegimeCounterBlock: "Current Regime Counter",
	BenchmarkComposition: "Benchmark Composition",
	ScenarioAnalysisEditable: "Scenario Analysis",
	CustomOutlookBlock: "Custom Outlook",
	WorldGridMapBlock: "World Grid Map",
};
